import { useQuery } from "@tanstack/react-query";
import { getTenancyInfo } from "@/api/v1-jwt/tenancy/tenancy";
import { useAuth } from "@/providers/auth";

export const useTenancy = ({
  userId,
  enabled,
  queryKey,
  queryFn,
  ...config
} = {}) => {
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  const isEnabled = !!id && enabled !== false;
  const currId = userId || id;
  return useQuery({
    queryKey: ["tenancy", currId],
    queryFn: () => getTenancyInfo(currId),
    enabled: isEnabled,
    ...config,
  });
};
